import { render } from "./SideSportBarCountries.vue?vue&type=template&id=348838be&scoped=true"
import script from "./SideSportBarCountries.vue?vue&type=script&lang=js"
export * from "./SideSportBarCountries.vue?vue&type=script&lang=js"

import "./SideSportBarCountries.vue?vue&type=style&index=0&id=348838be&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-348838be"]])

export default __exports__